export default "__VITE_ASSET__Dzt7f7ng__"